import React from "react";
import Header from "./Header";
import { Rocket, Contact } from "../assets";
import PopularPosts from "./PopularPosts";
import PopularWriters from "./PopularWriters";
import { popular } from "../utils/dummyData";

export default function LatestBlogs() {
  return (
    <section className="flex flex-col items-center justify-center mt-[2rem] mb-[4rem]">
      <Header
        title="Latest Blogs & Articles"
        subtitle="Collaborative Excellence for Your Success"
      />
      <div className="">
        <PopularPosts posts={popular?.posts} />
      </div>
    </section>
  );
}
